export default __webpack_public_path__ + "static/media/topLeft.796d21e1.svg";